import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class WeatherService {
    url = 'http://api.openweathermap.org/data/2.5/weather?lat=34.7314699&lon=10.7638818&appid=1e64dc35293d36bb960626641d7015a8&units=metric';
    temperature;
    meteo;
    constructor(
        private http: HttpClient,
        private datePipe: DatePipe
    ) {}

    getWeather() {
        return this.http.get(this.url);
    }

    getSavedWeather() {
        let weather = localStorage.getItem('weather');
        if (weather == null) {
            return this.getWeather()
                .subscribe((res: any) => {
                    this.temperature = res.main.temp;
                    this.meteo = res.weather[0].icon;
                    let cachedWeather = {
                        temperature: this.temperature,
                        meteo: this.meteo,
                        date: this.datePipe.transform(Date.now(), 'yyyy-MM-dd')
                    };
                    localStorage.setItem('weather', JSON.stringify(cachedWeather));
                });
        } else {
            let cachedWeather = JSON.parse(localStorage.getItem('weather'));
            if (cachedWeather.date) {
                let savedDate = new Date(cachedWeather.date);
                let now = Date.now();
                if (savedDate.setHours(0, 0, 0, 0) < new Date(now).setHours(0, 0, 0, 0)) {
                    localStorage.removeItem('weather');
                    this.getWeather();
                }
            }
            this.temperature = cachedWeather.temperature;
            this.meteo = cachedWeather.meteo;
            return null;
        }
    }
}